export const PlaybackSourceTypes = {
  CAROUSEL: 'carousel',
  SUGGESTED_NEXT: 'suggested-next',
  RECOMMENDATION: 'recommendation',
  SEARCH: 'search',
  CHANNELS: 'channels',
  CONTINUE_WATCHING: 'continue-watching',
  MY_LIST: 'my-list',
  HOME_AUTOPLAY: 'home-autoplay',
  DETAILS_AUTOPLAY: 'details-autoplay',
  CONTENT_DETAILS: 'content-details',
  DEEPLINK: 'deeplink',
  REFERRAL: 'referral',
  TAB_STOREFRONT: 'tab_storefront',
  AUTOPLAY_LINEAR: 'autoplay_linear',
  EPG_LINEAR: 'epg_linear',
  COLLECTION: 'collection',
} as const;

export type KnownPlaybackSourceType = (typeof PlaybackSourceTypes)[keyof typeof PlaybackSourceTypes];

// allows known values while still permitting arbitrary customer-specific strings
export type PlaybackSourceType = KnownPlaybackSourceType | (string & {});
